import lfRequest from "@/service/index";

export function chat(queryInfo: any) {
  return lfRequest.post<any>({
    url: '/main/ai/chat',
    data: queryInfo
  })
}

export function loadHistory(queryInfo: any) {
  return lfRequest.get<any>({
    url: '/main/ai/queryHistory',
    params: queryInfo
  })
}

export function loadMessages(queryInfo: any) {
  return lfRequest.get<any>({
    url: '/main/ai/queryHistoryBySessionId',
    params: queryInfo
  })
}

export function deleteHistory(queryInfo: any) {
  return lfRequest.delete<any>({
    url: '/main/ai/deleteHistoryBySessionId',
    params: queryInfo
  })
}
